import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Trash2 } from 'lucide-react';

const DeleteConfirmModal = ({ deleteConfirm, onClose, onDeletePost, onDeleteChallenge, onDeleteComment }) => {
  if (!deleteConfirm) return null;

  return (
    <AnimatePresence>
      {deleteConfirm && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: 20
          }}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white', borderRadius: 16, padding: 24,
              maxWidth: 320, width: '100%', textAlign: 'center'
            }}
          >
            <div style={{
              width: 56, height: 56, background: '#FEE2E2', borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <Trash2 size={28} color="#EF4444" />
            </div>
            <h3 data-testid="delete-confirm-title" style={{ fontSize: 18, fontWeight: 700, color: '#1F2937', marginBottom: 8 }}>
              Delete {deleteConfirm.type === 'challenge' ? 'Action' : deleteConfirm.type === 'post' ? 'Post' : 'Comment'}?
            </h3>
            <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 20 }}>
              This action cannot be undone.
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={onClose} data-testid="delete-cancel-btn"
                style={{
                  flex: 1, padding: '12px 16px', background: '#F3F4F6', border: 'none',
                  borderRadius: 10, fontSize: 14, fontWeight: 600, color: '#4B5563', cursor: 'pointer'
                }}>
                Cancel
              </button>
              <button data-testid="delete-confirm-btn"
                onClick={() => {
                  if (deleteConfirm.type === 'post') onDeletePost(deleteConfirm.id);
                  else if (deleteConfirm.type === 'challenge') onDeleteChallenge(deleteConfirm.id);
                  else if (deleteConfirm.type === 'comment') onDeleteComment(deleteConfirm.id, deleteConfirm.postId);
                }}
                style={{
                  flex: 1, padding: '12px 16px', background: '#EF4444', border: 'none',
                  borderRadius: 10, fontSize: 14, fontWeight: 600, color: 'white', cursor: 'pointer'
                }}>
                Delete
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DeleteConfirmModal;
